
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/id-generator",
      function () {
        return require("private-next-pages/id-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/id-generator"])
      });
    }
  